import { useQuery } from 'react-query'
import { ApiCall } from 'services'

function useWbsoQuestions(props) {
  const options = props?.options || {}

  const queryKey = ['get-wbso-question', props]
  const query = useQuery(
    queryKey,
    () => ApiCall.wbso.getQuestions(props?.uuid),
    {
      ...options,
      staleTime: 1000 * 60 * 5,
    },
  )

  return {
    ...query,
    data: query?.data?.data ?? [],
  }
}

export default useWbsoQuestions
